import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class CostSettingProfileSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    costs: { embedded: 'always' },
    createdAt: { serialize: false },
    updatedAt: { serialize: false },
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'profile' || key === 'profiles') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      return super.modelNameFromPayloadKey('cost-setting/profile');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    return super.modelNameFromPayloadKey(key);
  }

  payloadKeyFromModelName(): string {
    return 'profile';
  }
}
